import { useState, useEffect } from 'react';
import { useAppSelector } from 'store/store-hooks';
import { useBackup } from 'components/app/editor/_mediator/backup/use-backup-cb';

import { AppButton } from 'components/app/app-components/app-button/app-button';
import { BackupModal } from './_editor-backup-modal';
import styles from './_editor-backup.module.scss';

export const EditorBackup = () => {
  const { backups, index } = useAppSelector((state) => state.backup);
  const [redoIsDisabled, setRedoIsDisabled] = useState(false);
  const [undoIsDisabled, setUndoIsDisabled] = useState(false);
  const [hover, setHover] = useState(false);
  const backupCb = useBackup();

  useEffect(() => {
    setUndoIsDisabled(index === 0);
    setRedoIsDisabled(backups.length === 0 || index === backups.length - 1);
  }, [backups, index]);

  return (
    <>
      <div className={styles.Backup} onMouseEnter={() => setHover(true)} onMouseLeave={() => setHover(false)}>
        <AppButton
          outlined
          disabled={undoIsDisabled}
          onClick={() => backupCb('undo')}
          tip="Undo the last action"
          tipPosition="left"
        >
          Undo
        </AppButton>
        <AppButton
          outlined
          disabled={redoIsDisabled}
          onClick={() => backupCb('redo')}
          tip="Redo the last undone action"
          tipPosition="left"
        >
          Redo
        </AppButton>
      </div>
      <BackupModal hover={hover} />
    </>
  );
};
